import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

export type CheckboxProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  disabled?: boolean;
  id?: string;
  title?: string;
  "aria-label"?: string;
  /** `power` = circular IEC power glyph for effect on/off. */
  variant?: "default" | "power";
};

/**
 * Adam-styled Radix checkbox — drop-in for instrument / FX toggles.
 */
export function Checkbox({
  checked,
  onCheckedChange,
  className,
  disabled,
  id,
  title,
  "aria-label": ariaLabel,
  variant = "default",
}: CheckboxProps) {
  const rootClass = [
    "adam-checkbox",
    variant === "power" ? "adam-checkbox--power" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <CheckboxPrimitive.Root
      id={id}
      className={rootClass}
      checked={checked}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
      onCheckedChange={value => onCheckedChange(value === true)}
    >
      {variant === "power" ? (
        <span className="adam-checkbox-power-icon" aria-hidden="true">
          <svg viewBox="0 0 12 12" width="11" height="11">
            {/* Vertical stem of the IEC power mark */}
            <path
              d="M6 1.6v3.6"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.55"
              strokeLinecap="round"
            />
            {/* Broken ring around the stem */}
            <path
              d="M3.15 3.45a3.35 3.35 0 1 0 5.7 0"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.55"
              strokeLinecap="round"
            />
          </svg>
        </span>
      ) : (
        <CheckboxPrimitive.Indicator className="adam-checkbox-indicator">
          <svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true">
            <path
              d="M2.2 6.2 4.8 8.8 9.8 3.2"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CheckboxPrimitive.Indicator>
      )}
    </CheckboxPrimitive.Root>
  );
}
